// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"be3f0617","670":"bd12cea9"}[chunkId] + ".chunk.js";
};